'use client';

import type { CmsApiPost } from '#/modules/cms/api/types/CmsApiDocument';
import { useReloadIfFreeCodeBlockAndClientNavigation } from '#/modules/cms/hooks/useReloadIfFreeCodeBlockAndClientNavigation';
import { DynamicNotFoundPage } from '#/pages/NotFound/DynamicNotFoundPage';

import { CmsPostBody } from './Body/CmsPostBody';
import { CmsPostLayout } from './Layout/CmsPostLayout';

type Props = {
  content: CmsApiPost;
};

export function CmsPostPage({ content }: Props) {
  const { showPageNotFound } =
    useReloadIfFreeCodeBlockAndClientNavigation(content);
  if (showPageNotFound) return <DynamicNotFoundPage />;

  return (
    <CmsPostLayout content={content}>
      <CmsPostBody content={content} />
    </CmsPostLayout>
  );
}
